import React from 'react';
import { createPortal } from 'react-dom';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { FaBug } from 'react-icons/fa';
import { useAuth } from '../../contexts/AuthContext';
import { auth } from '../../firebase';
import './ReportBugButton.css';

const HIDDEN_PATHS = new Set(['/login', '/session-expired', '/unauthorized']);

const ReportBugButton = () => {
  const { currentUser } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const isAuthenticated = Boolean(currentUser || auth.currentUser);

  if (!isAuthenticated || HIDDEN_PATHS.has(location.pathname)) {
    return null;
  }

  return createPortal(
    <Button
      variant="primary"
      className="report-bug-button"
      onClick={() => navigate('/it-requests')}
      aria-label="Report a bug"
    >
      <FaBug className="report-bug-button__icon" aria-hidden="true" />
      <span className="report-bug-button__label">Report a Bug</span>
    </Button>,
    document.body
  );
};

export default ReportBugButton;
